import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractGitEntityStore } from '@y42/feature/git/state';
import { VisualizationCanvasElementGitFactoryService } from './visualization-canvas-element-git-factory.service';
import {
  VisualizationCanvasElementState,
  VisualizationCanvasElementStoreModel,
} from './visualization-canvas-element.model';

const initialState: VisualizationCanvasElementState = {
  loading: true,
  ui: {
    currentSelectionIds: [],
  },
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'visualization-canvas-element', idKey: '$path' })
export class VisualizationCanvasElementStore extends AbstractGitEntityStore<VisualizationCanvasElementState> {
  constructor(protected readonly gitFactory: VisualizationCanvasElementGitFactoryService) {
    super({ name: 'Visualization-Canvas', gitFactory, initialState });
  }

  updateCurrentSelectionIds(currentSelectionIds: string[]) {
    this.update((state) => ({ ...state, ui: { ...state.ui, currentSelectionIds } }));
  }

  updateClipboard(clipboard?: VisualizationCanvasElementStoreModel[]) {
    this.update((state) => ({ ...state, ui: { ...state.ui, clipboard } }));
  }
}
